import { ComparisonSection } from "@/features/clients/components/comparison-section";
import { useActiveClient } from "@/layouts/client-layout";

export default function ClientComparisonPage() {
  const { client } = useActiveClient();
  return (
    <div className="space-y-6">
      <ComparisonSection client={client} />
    </div>
  );
}
